import { defineField, defineType } from 'sanity'

import getPageInfo, { seoGroup } from '../../objects/pageInfo'

export default defineType({
  title: 'Memorial Day Sale',
  name: 'memorialDay',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      name: 'phases',
      title: 'Phases',
      type: 'array',
      of: [{ type: 'specialEventPhase' }],
      validation: (rule) => [rule.min(1), rule.max(4)],
      group: 'content',
    }),
    getPageInfo({ lockCanonical: true }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})
